import { LitElement, PropertyDeclarations } from 'lit';
import { SkeletonAlignmentProp } from '../../types/props.js';
import { BaseSkeletonInterface } from './BaseSkeletonInterface.js';

export class BaseGenericElement
  extends LitElement
  implements BaseSkeletonInterface
{
  declare alignment?: SkeletonAlignmentProp;

  declare height?: string;

  declare width?: string;

  static override properties: PropertyDeclarations = {
    /**
     * Positions the skeleton loading inside the container
     * @values start, center, end
     * @default start
     */
    alignment: { type: String, reflect: true },
    /**
     * Sets the height of the skeleton loading
     */
    height: { type: String },
    /**
     * Sets the width of the skeleton loading
     */
    width: { type: String },
  };
}
